
import type { HierarchicalFilter } from '@empathyco/x-types'
import type { PropType } from 'vue'
import { StaggeredFadeAndSlide } from '@empathyco/x-components'
import { FiltersList, FiltersSearch, SlicedFilters } from '@empathyco/x-components/facets'
import { defineComponent } from 'vue'
import SearchBox from '../../shared/search-box.component.vue'
import XFilter from './x-filter.component.vue'

export default defineComponent({
  name: 'XFiltersList',
  components: {
    FiltersSearch,
    SearchBox,
    SlicedFilters,
    FiltersList,
    XFilter,
  },
  props: {
    filters: {
      type: Array as PropType<Array<HierarchicalFilter>>,
      required: true,
    },
    max: {
      type: Number,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  data(): Record<string, any> {
    return {
      baseClass: 'epb-x-filters-list',
      animation: StaggeredFadeAndSlide,
    }
  },
  computed: {
    parentFilters(): Array<HierarchicalFilter> {
      return this.filters.filter(({ parentId }) => parentId === null)
    },
    hasFacetChildrenSelected(): boolean {
      return this.filters.some(({ parentId, selected }) => parentId && selected)
    },
  },
})
